export const maxPicturesAllowed = 6;
